import { useEffect, useState } from "react";
import { Box, Button, Card, CardActions, CardContent, Typography, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import api from "../../api/client";

const Invoices = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const { data } = await api.get("/api/templates/files");
        if (!active) return;
        setItems(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error(e);
        if (active) setItems([]);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, []);

  const toTemplateUrl = (p) => {
    if (!p) return "";
    if (/^(https?:)?\/\//i.test(p) || p.startsWith("/")) return p;
    return `/${p}`;
  };

  return (
    <Box m="20px">
      <Header title="TEMPLETS" subtitle="Auto-loaded from public/templets folder" />
      <Box
        m="24px 0 0 0"
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
          gap: 2,
        }}
      >
        {items.map((tpl) => {
          const href = toTemplateUrl(tpl.path);
          return (
            <Card key={tpl.name} sx={{ bgcolor: colors.primary[400], border: `1px solid ${colors.primary[300]}` }}>
              <Box sx={{ position: "relative", width: "100%", pt: "100%", overflow: "hidden", borderBottom: `1px solid ${colors.primary[300]}` }}>
                <iframe
                  title={tpl.title}
                  src={href}
                  loading="lazy"
                  scrolling="no"
                  style={{
                    position: "absolute",
                    left: 0,
                    top: 0,
                    width: "1500px",
                    height: "1500px",
                    border: 0,
                    transformOrigin: "top left",
                    transform: "scale(0.18)",
                    pointerEvents: "none",
                  }}
                />
              </Box>
              <CardContent>
                <Typography fontWeight={700} noWrap title={tpl.title}>
                  {tpl.title}
                </Typography>
              </CardContent>
              <CardActions sx={{ pt: 0 }}>
                <Button size="small" color="secondary" variant="outlined" onClick={() => window.open(href, "_blank")}>
                  View Layout
                </Button>
                <Button
                  size="small"
                  color="secondary"
                  variant="contained"
                  onClick={() => window.open(`layoutEditor.html?layout=${encodeURIComponent(tpl.title)}`, "_blank")}
                >
                  Edit Layout
                </Button>
              </CardActions>
            </Card>
          );
        })}
      </Box>
      {!loading && items.length === 0 ? (
        <Typography mt={2} color={colors.grey[300]}>
          No template HTML files found in public/templets.
        </Typography>
      ) : null}
    </Box>
  );
};

export default Invoices;
